import LocalStorageManager from "./LocalStorageManager.service";

class AutenticationService{
    static isAutenticate = () => {
        let val = LocalStorageManager.getItem('s_islogged') ??false;        
        return val;
    }
        
    static getUser = () => LocalStorageManager.getItem('s_sid')??'';
    static getUserName = () => LocalStorageManager.getItem('s_name')??'';
    static getUserNameComplete = () => {
        const name = LocalStorageManager.getItem('s_name') || '';
        const fname = LocalStorageManager.getItem('s_fname') || '';
        return `${name} ${fname}`.trim();
    };
    static getEmail = () => LocalStorageManager.getItem('s_email')??'';
    static getPPID = () => LocalStorageManager.getItem('s_ppid')??'';
    static getIsLogged = () => {
        const value = LocalStorageManager.getItem('s_islogged');
        if (!value || value === 'false' || value === 'null') return false;
        if (value === 'true') return true;
        return !!value;
    };
    
    static getRegistered = () => LocalStorageManager.getItem('s_status')==="completed"||LocalStorageManager.getItem('s_status')==="active";
}

export default AutenticationService;